import {
    ERROR,
    SYNCHRO_GET_ACTIVE_USER,
    USER_SYNCHRO_CODE,
    WAITING_REQUESTS_SYNCHRO_CODE,
    DEFAULT_SYNCHRO_PERIOD_IN_MINUTES,
    SYNCHO_PERIODS_SYNCHRO_CODE,
    SITE_MONITORING_SYNCHRO_CODE
} from "./synchroConstants";
import { setFilteredAndSortedSiteMonitorings, synchronizeSiteMonitorings } from '../siteMonitoring/siteMonitoringActions';
import db from '../../db';
import { fetchWithTimeout } from '../../lib/fetch_wrapper';
import { throwErrorMessage } from '../../lib/error_helper';
import { actualizeWaitingRequests } from "../serviceWorker/swActions";
import moment from "moment";
import { getActiveUser } from '../users/usersActions'

export function getAllData() {
    return () => {

    };
}

export function bgSyncApi(hideError = false) {
    return (dispatch) => {
        const headers = new Headers({ 'Content-Type': 'application/json' });
        fetchWithTimeout('/bgSync', {
            method: 'GET',
            headers: headers,
            externalRequest: true
        }).catch((err) => {
            console.error("Erreur : keystoneSynchroActions - bgSyncApi", err);
            if (hideError)
                return;
            dispatch(throwErrorMessage({
                errorObject: err,
                title: "Erreur",
                message: "Erreur lors de la synchronisation !",
            }))
        });
    };
}

export function getDefaultSyncState() {
    return {
        activeUser: null,
        locationTitle: null,
        timer_sync: null,
    };
}

export function getSynchroActiveUser(currentState, hideError = false) {
    return (dispatch) => {
        dispatch(bgSyncApi(hideError));

        return db.User.limit(1).first().then(user => {
            if (user) {
                dispatch({ type: SYNCHRO_GET_ACTIVE_USER, payload: user })
            }
        }).catch((err) => {
            console.error("Erreur : externalSynchroActions - getSynchroActiveUser", err)
            dispatch(throwErrorMessage({
                errorObject: err,
                title: "Erreur",
                message: "Erreur lors de la récupération de l'utilisateur actif !",
            }))
            dispatch({ type: ERROR, info: ("Récupération de l'utilisateur actif"), error: err });
        });
    };
}

export function initSynchronisations(state, stateAccessor, history, interventionsFilters, siteMonitoringsFilters) {
    return (dispatch) => {
        console.info("Lancement des synchronisations périodiques")

        let promises = []
        getSynchroMapping().forEach((synchroType) => {
            promises.push(initializeSynchroInDb(synchroType))
        })

        Promise.all(promises).then(() => {
            dispatch(infiniteSynchronization(state, stateAccessor, history, interventionsFilters, siteMonitoringsFilters))
        })
    }
}

/** Synchronisation récursive
 */
export function infiniteSynchronization(state, stateAccessor, history, interventionsFilters, siteMonitoringsFilters) {
    return (dispatch) => {
        setInterval(() => {
            dispatch(synchronization(state, stateAccessor, history, interventionsFilters, siteMonitoringsFilters))
        }, DEFAULT_SYNCHRO_PERIOD_IN_MINUTES * 60000)
    }
}

export function synchronization(state, stateAccessor, history, interventionsFilters, siteMonitoringsFilters, force = false) {
    return (dispatch) => {

        db.Synchronisations.toArray().then((allSynchro) => {
            allSynchro.forEach((synchro) => {

                if (!force && moment(synchro.nextSynchroDate, "DD/MM/YYYY HH:mm:ss") > moment())
                    return

                let currentSynchroType = getSynchroMapping().find((synchroType) => synchroType.code === synchro.typeCode)
                if (!currentSynchroType) {
                    console.error("Synchronisation en erreur car le type de synchro est introuvable");//Should never happen
                    return;
                }

                //Lancement de la requête de synchronisation
                currentSynchroType.synchroFunction(dispatch, history, { state, interventionsFilters, stateAccessor, siteMonitoringsFilters });
                let nextSynchroDate = moment().add(synchro.periodInMinutes, "minute").format("DD/MM/YYYY HH:mm:ss");

                //Mise à jour de la date de prochaine synchro
                db.Synchronisations.update(synchro.typeCode, { nextSynchroDate }).catch((err) => console.error(err))
            })
        })
    }
}

/** On initialise la table de synchronisations */
function initializeSynchroInDb(synchroType) {
    return new Promise((resolve, reject) => {
        db.transaction("rw", db.Synchronisations, () => {
            db.Synchronisations.get({ typeCode: synchroType.code }, (dbPeriod) => {
                if (dbPeriod) {
                    return resolve(dbPeriod);//Déjà initialisé
                }

                let synchroAsDbFormat = {
                    typeCode: synchroType.code,
                    periodInMinutes: DEFAULT_SYNCHRO_PERIOD_IN_MINUTES,
                    nextSynchroDate: moment().format("DD/MM/YYYY HH:mm:ss")//On veut que la synchro se lance une première fois dès le début
                }

                return resolve(db.Synchronisations.put(synchroAsDbFormat))
            }).catch((err) => {
                console.error(err);
                return reject(err)
            })
        })
    })
}

function getSynchroPeriods() {

    const headers = new Headers({ 'Content-Type': 'application/json' });
    fetchWithTimeout('/api/v1/synchro_periods', {
        method: 'GET',
        headers,
    }).then((response) => {
        if (!response.ok) {
            throw Error(response.statusText);
        }

        return response;
    }).then((response) => {
        return response.json()
    }).then((serverPeriods) => {
        serverPeriods.forEach((serverPeriod) => {
            db.Synchronisations.get({ typeCode: serverPeriod.code }).then((dbPeriod) => {
                if (dbPeriod) {
                    if (dbPeriod.periodInMinutes !== serverPeriod.periodInMinutes) {
                        dbPeriod.periodInMinutes = serverPeriod.periodInMinutes
                        db.Synchronisations.update(dbPeriod.typeCode, dbPeriod)
                    }

                    return;
                }

                let synchroAsDbFormat = {
                    typeCode: serverPeriod.code,
                    periodInMinutes: serverPeriod.periodInMinutes,
                    nextSynchroDate: moment().add(serverPeriod.periodInMinutes, "minute").format("DD/MM/YYYY HH:mm:ss")
                }

                db.Synchronisations.put(synchroAsDbFormat)
            })
        })
    }).catch((err) => {
        console.error("Erreur : externalSynchroActions - getSynchroPeriods", err)
    })
}

function getSynchroMapping() {
    return [
        {
            code: WAITING_REQUESTS_SYNCHRO_CODE,
            synchroFunction: (dispatch) => {
                //On actualise la liste des requêtes en attente
                //C'est asynchrone donc on attend avant de lancer l'actualisation
                //Pas moyen de savoir lorsque les requêtes ont été rejouées
                dispatch(actualizeWaitingRequests)
            }
        },
        {
            code: SYNCHO_PERIODS_SYNCHRO_CODE,
            synchroFunction: () => {
                getSynchroPeriods();
            }
        },
        {
            code: USER_SYNCHRO_CODE,
            synchroFunction: (dispatch, history, options) => {
                const { state } = options;
                dispatch(getSynchroActiveUser(state, true));
            }
        },
        {
            code: SITE_MONITORING_SYNCHRO_CODE,
            synchroFunction: (dispatch, history, options) => {
                const { siteMonitoringsFilters } = options;
                getActiveUser().then((activeUser) => {
                    dispatch(synchronizeSiteMonitorings(activeUser, history, () => {
                        if (siteMonitoringsFilters) {
                            dispatch(setFilteredAndSortedSiteMonitorings({ ...siteMonitoringsFilters }, null, activeUser.id))
                        }
                    }, siteMonitoringsFilters, true));
                })
            }
        },
    ]
}
